export enum EHashLinks {
  home = 'home',
  experience = 'experience',
  education = 'education',
  profile = 'profile',
}
